/* tslint:disable */
/* eslint-disable */
export enum InsuranceProductType {
  None = 'None',
  Mbi = 'Mbi',
  Mvi = 'Mvi',
  Ppi = 'Ppi',
  Cci = 'Cci',
  Lpi = 'Lpi',
  Gap = 'Gap'
}
